import {
    lazyLogSearchActions,
    lazyLogSearchEntityActions,
    lazyLogSearchSuggestionsResultsRenderedEvent,
} from 'owa-search-instrumentation';
import type { SonoraSuggestionsResults } from 'owa-editor-sonora-types';
import SubstrateSearchScenario from 'owa-search-service/lib/data/schema/SubstrateSearchScenario';
import type { SearchActionsEventType } from 'owa-search-instrumentation/lib/data/schema/substrateSearchLogTypes';

export function log3sSearchAction(
    result: SonoraSuggestionsResults,
    actionEventType: SearchActionsEventType
) {
    let logicalId: string = '';
    let traceId: string = '';

    // 3S file suggestions
    if (result.fileSuggestions?.suggestions?.length > 0) {
        logicalId = result.fileSuggestions.logicalId ?? '';
        traceId = result.fileSuggestions.traceId ?? '';

        lazyLogSearchActions.importAndExecute(
            SubstrateSearchScenario.SonoraFilePicker,
            '' /* userId */,
            '' /* tenantId */,
            logicalId /* logicalId */,
            traceId /* traceId */,
            actionEventType as SearchActionsEventType /* searchActionsEventType */
        );
    }

    // 3S Query search for Stickynotes
    if (result.stickyNotesSuggestions?.suggestions?.length > 0) {
        logicalId = result.stickyNotesSuggestions.logicalId ?? '';
        traceId = result.stickyNotesSuggestions.traceId ?? '';
        lazyLogSearchActions.importAndExecute(
            SubstrateSearchScenario.SonoraHoneybee,
            '' /* userId */,
            '' /* tenantId */,
            logicalId /* logicalId */,
            traceId /* traceId */,
            actionEventType as SearchActionsEventType /* searchActionsEventType */
        );
    }

    // 3S people suggestions
    if (result.contactSuggestions?.suggestions?.length > 0) {
        logicalId = result.contactSuggestions.logicalId ?? '';
        traceId = result.contactSuggestions.traceId ?? '';

        lazyLogSearchActions.importAndExecute(
            SubstrateSearchScenario.SonoraFilePicker,
            '' /* userId */,
            '' /* tenantId */,
            logicalId /* logicalId */,
            traceId /* traceId */,
            actionEventType as SearchActionsEventType /* searchActionsEventType */
        );
    }
}
export function log3sEntityClickedAction(
    logicalId: string,
    traceId: string,
    scenarioName: SubstrateSearchScenario
) {
    lazyLogSearchEntityActions.importAndExecute(
        scenarioName,
        '' /* userId */,
        '' /* tenantId */,
        logicalId /* logicalId */,
        traceId /* traceId */,
        '' /* referenceId */,
        'EntityClicked' /* eventType */
    );
}

export function log3sRenderAction(result: SonoraSuggestionsResults, e2eLatencyInMS: number) {
    if (e2eLatencyInMS > 0) {
        let logicalId: string = '';
        let traceId: string = '';

        // 3S Suggestions for files
        if (result.fileSuggestions?.suggestions?.length > 0) {
            logicalId = result.fileSuggestions.logicalId ?? '';
            traceId = result.fileSuggestions.traceId ?? '';
            lazyLogSearchSuggestionsResultsRenderedEvent.importAndExecute(
                SubstrateSearchScenario.SonoraFilePicker,
                logicalId /* logicalId */,
                traceId /* traceId */,
                e2eLatencyInMS /* e2eLatency */
            );
        }

        //3s Query search for Stickynotes
        if (result.stickyNotesSuggestions?.suggestions?.length > 0) {
            logicalId = result.stickyNotesSuggestions.logicalId ?? '';
            traceId = result.stickyNotesSuggestions.traceId ?? '';
            lazyLogSearchSuggestionsResultsRenderedEvent.importAndExecute(
                SubstrateSearchScenario.SonoraHoneybee,
                logicalId /* logicalId */,
                traceId /* traceId */,
                e2eLatencyInMS /* e2eLatency */
            );
        }

        // 3S Suggestions for people
        if (result.contactSuggestions?.suggestions?.length > 0) {
            logicalId = result.contactSuggestions.logicalId ?? '';
            traceId = result.contactSuggestions.traceId ?? '';
            lazyLogSearchSuggestionsResultsRenderedEvent.importAndExecute(
                SubstrateSearchScenario.SonoraFilePicker,
                logicalId /* logicalId */,
                traceId /* traceId */,
                e2eLatencyInMS /* e2eLatency */
            );
        }
    }
}
